<template>
    <img v-for="image in images" :class="{'hidden':image.id!==images[active-1].id}"
         class="w-full h-full" :src='"/uploads/carousel/" + image.name'>
</template>

<script setup>
import {computed, ref} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

let active = ref(1);

const images = computed(() => usePage().props.value.carousel)

setInterval(() => {
    if (active.value + 1 > images.value.length) {
        active.value = 1;
    } else {
        active.value++;
    }
}, 10000)
</script>
